import React from 'react';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {WF_BINDING_DATA_KEY} from '@packages/systems/commerce/constants';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const CommerceCheckoutOrderItemOptionListItemLabel = Atom.createRender(
  (props) => {
    const {attributes, classes, context, generateAttributes, innerHTML} = props;
    const label = context.get('label', '');
    const newAttributes = {
      ...generateAttributes(attributes, classes),
      [WF_BINDING_DATA_KEY]: encodeURIComponent(
        JSON.stringify([
          {
            innerHTML: {
              type: 'PlainText',
              filter: {type: 'identity', params: []},
              dataPath: context
                .get('bindingPathPrefix', [])
                .concat(['name'])
                .join('.'),
            },
          },
        ])
      ),
    } as const;
    return (
      <span {...newAttributes}>
        {innerHTML
          ? // TODO (platform): fix innerHTML type issues

            innerHTML
          : label}
      </span>
    );
  }
);

const config = createIntegratedAtom({
  showEmpty: false,
  displayName: 'Text Block',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  constraints: {
    pinToParent: true,
    ancestors: [
      {
        is: 'CommerceCheckoutOrderItemOptionListItem',
        rule: 'ExactlyOne',
      },
    ],
  },
  render: CommerceCheckoutOrderItemOptionListItemLabel,
  fields: {},
});

export default config;
